export interface MetricItem {
  label: string;
  value: number;
  stageKey?: string;
  bgColor?: string;
}

export interface StageChartItem {
  status: string;
  value: number;
  color: string;
  textColor?: string;
  stageKey: string;
}

export const STAGE_CHART_COLORS: Record<string, string> = {
  open: "#252b37",
  "in-progress": "#f76808cc",
  resolved: "#1276e2cc",
  closed: "#10b981",
  "waiting-on-3rd-party": "#9e49abcc",
  "waiting-on-site": "#1276e2cc",
  dropped: "#e13f41cc",
};

export const STAGE_CHART_COLORS_DARK: Record<string, { bg: string; text: string }> = {
  open: { bg: "#fbfbfb", text: "#252b37" },
};

export const DEFAULT_CHART_COLOR = "rgba(158,73,171,0.8)";

export interface PriorityChartItem {
  id: string;
  label: string;
  tickets: number;
  value: number;
  displayPercent: string;
  color: string;
  rowBg: string;
  rowBgDk: string;
  flagColor: string;
  hasFlag: boolean;
}

interface PriorityStyleConfig {
  label: string;
  color: string;
  rowBg: string;
  rowBgDk: string;
  flagColor: string;
  hasFlag: boolean;
}

export const PRIORITY_CHART_CONFIG: Record<string, PriorityStyleConfig> = {
  high: {
    label: "High",
    color: "#ef4444",
    rowBg: "#fef2f2",
    rowBgDk: "rgba(239,68,68,0.12)",
    flagColor: "#ef4444",
    hasFlag: true,
  },
  medium: {
    label: "Moderate",
    color: "#eac11d",
    rowBg: "#fefce8",
    rowBgDk: "rgba(250,204,21,0.12)",
    flagColor: "#eac11d",
    hasFlag: true,
  },
  low: {
    label: "Low",
    color: "#3b82f6",
    rowBg: "#eff6ff",
    rowBgDk: "rgba(59,130,246,0.12)",
    flagColor: "#3b82f6",
    hasFlag: true,
  },
  na: {
    label: "N/A (Feature)",
    color: "#e2e8f0",
    rowBg: "#F4F4F4",
    rowBgDk: "#636770",
    flagColor: "#94a3b8",
    hasFlag: false,
  },
};

export interface SlaComplianceData {
  withinSla: { count: number; percentage: number };
  withoutSla: { count: number; percentage: number };
  total: number;
}

export const DEFAULT_PRIORITY_CONFIG: PriorityStyleConfig = {
  label: "Other",
  color: "#94a3b8",
  rowBg: "#f8fafc",
  rowBgDk: "rgba(148,163,184,0.12)",
  flagColor: "#94a3b8",
  hasFlag: false,
};

export const MONTH_NAMES = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];